const MultiSelector = ({
    packages,
    onChange,
    label = "Package",
}) => {
    return (
        <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-medium text-gray-700 mr-1">
                {label}
            </span>

            {Object.keys(packages).map((pkg) => {
                const isSelected = !!packages[pkg];

                return (
                    <button
                        key={pkg}
                        type="button"
                        onClick={() =>
                            onChange(pkg, !isSelected)
                        }
                        className={`
                            flex items-center gap-2
                            px-3 py-1.5
                            rounded-full border
                            text-sm shadow-sm
                            transition-all duration-200
                            ${
                                isSelected
                                    ? "bg-blue-50 border-blue-600 text-blue-700"
                                    : "bg-white border-gray-200 text-gray-600"
                            }
                        `}
                    >
                        <span className="font-medium whitespace-nowrap">
                            {pkg}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default MultiSelector;